import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
    '2xs': { value: { fontSize: '2xs', lineHeight: 1.6 } },
    xs: { value: { fontSize: 'xs', lineHeight: 'calc(16 / 12)' } },
    sm: { value: { fontSize: 'sm', lineHeight: 'calc(20 / 14)' } },
    md: { value: { fontSize: 'md', lineHeight: 1.5 } },
    lg: { value: { fontSize: 'lg', lineHeight: 'calc(24 / 18)' } },
    xl: { value: { fontSize: 'xl', lineHeight: 1.2 } },
    '2xl': { value: { fontSize: '2xl', lineHeight: 1.25 } },
    '3xl': { value: { fontSize: '3xl', lineHeight: 'calc(34 / 28)' } },
    '4xl': {
        value: {
            fontSize: '4xl',
            lineHeight: 'calc(42 / 36)',
        },
    },
    '5xl': {
        value: {
            fontSize: '5xl',
            lineHeight: 1.1,
            // letterSpacing: '-0.025em',
        },
    },
    '6xl': {
        value: {
            fontSize: '6xl',
            lineHeight: 1,
            // letterSpacing: '-0.025em'
        },
    },
    '7xl': {
        value: {
            fontSize: '7xl',
            lineHeight: 1,
            // letterSpacing: '-0.025em',
        },
    },
    none: {
        value: {},
    },
    label: {
        value: {
            fontSize: 'sm',
            lineHeight: 'calc(20 / 14)',
        },
    },
});
